import * as classnames from 'classnames'
import * as React from 'react'

import * as styles from './button.module.css'

interface IDictionary {
  [key: string]: any
}

type ButtonAnchorHTMLAttributes = React.ButtonHTMLAttributes<
  HTMLButtonElement
> &
  React.AnchorHTMLAttributes<HTMLAnchorElement> &
  IDictionary

enum ButtonType {
  Primary = 'primary',
  Pill = 'pill'
}

interface IProps extends ButtonAnchorHTMLAttributes {
  large?: boolean
  fixedWidth?: boolean
  type?: ButtonType
  renderAs?: React.ComponentType<any>
}

interface IButton extends React.SFC<IProps> {
  Type: typeof ButtonType
}

const tagType = (href: string | undefined) => {
  return href ? 'a' : 'button'
}

const Button: IButton = props => {
  const {
    className,
    children,
    large,
    fixedWidth,
    renderAs,
    type,
    ...nextProps
  } = props
  const Tag: React.ComponentType<any> | string = renderAs
    ? renderAs
    : tagType(nextProps.href)
  const nextClassName = classnames(styles.button, className, {
    [styles.large]: large,

    [styles.fixedWidth]: fixedWidth,
    [styles.typePrimary]: type === ButtonType.Primary,
    [styles.typePill]: type === ButtonType.Pill
  })

  return (
    <Tag className={nextClassName} {...nextProps}>
      {children}
    </Tag>
  )
}

Button.Type = ButtonType

export default Button
